'use strict';

angular.module('myConsultApp')
	  .directive('gauge', function () {
	    return {
			templateUrl: 'templates/gauge.html',
			restrict: 'A',
			scope: {
			  gaugevalue: '@showvalue',
			  random: '=?'
			},
	        link: function(scope, elem, attr){
					var opts = {
						lines: 12, // The number of lines to draw
						angle: 0.0, // The length of each line
						lineWidth: 0.44, // The line thickness
						pointer: {
							length: 0, // The radius of the inner circle
							strokeWidth: 0, // The rotation offset
							color: '#000000' // Fill color
						},
						limitMax: 'false',   // If true, the pointer will not go past the end of the gauge
						percentColors: [[0.0, "#5CB85C" ],[0.25, "#5CB85C"], [0.40, "#F3AC34"], [0.55, "#F3AC34"], [1.0, "#C54D4F"]],
						strokeColor: '#e7e7e7',   // to see which ones work best for you
						generateGradient: false
					};

					var target = elem.find('.gauge-canvas')[0]; // your canvas element
					var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
					gauge.maxValue = 100; // set max gauge value
					gauge.animationSpeed = 20; // set animation speed (32 is default value)				
					gauge.set(0.1);//set default value


					scope.$watch('gaugevalue', function(newVal) {
						var setValue = scope.gaugevalue != 0 && !isNaN(scope.gaugevalue)  ? scope.gaugevalue*100 : 1;
						gauge.set(setValue); // set actual value
						scope.$root.$broadcast('fix-findapatient-ui');
					});
	        }
    };
});
